import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import instance from "../../../config/Config";

const initialState = {
    data: null,
    loading: false,
    error: null,
    count: null,
};

export const fetchEmailRecord = createAsyncThunk(
    "fetchEmailRecord",
    async (body) => {
        try {
            const response = await instance.get(
                `/crm/email-system/email-record-list?page=${body.page}&search=${body.search}`
            );
            return response.data;
        } catch (error) {
            throw error;
        }
    }
);


export const EmailSlice = createSlice({
    name: "EmailSlice",
    initialState,

    reducers: {},
    extraReducers: (builder) => {
        builder.addCase(fetchEmailRecord.pending, (state, action) => {
            state.loading = true;
        });
        builder.addCase(fetchEmailRecord.fulfilled, (state, action) => {
            console.log(action.payload,"sgjh")
            state.loading = false;
            state.data = action.payload;
            state.count = action.payload?.count;


        });
        builder.addCase(fetchEmailRecord.rejected, (state, action) => {
            state.loading = false;
            state.error = action.payload;
        });
    },
});

export default EmailSlice.reducer;
